






















import Vue from 'vue'

export default Vue.extend({
  name: 'Progress',
  props: {
    totalSteps: {
      type: Number,
      default: 5,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    progress(): number {
      return (this.currentStep / this.totalSteps) * 100
    },
    currentStepRange(): number[] {
      return Array.from({ length: this.currentStep }, (_, i) => i + 1)
    },
    totalStepsRange(): number[] {
      return Array.from({ length: this.totalSteps + 1 }, (_, i) => i + 1)
    },
  },
})
